import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "charge-fee-container" }
const _hoisted_2 = {
  key: 0,
  class: "charge-fee-summary mt-10"
}
const _hoisted_3 = { class: "mr-20" }
const _hoisted_4 = { style: {"color":"#67c23a"} }
const _hoisted_5 = { class: "mr-20" }
const _hoisted_6 = { style: {"color":"#e6a23c"} }
const _hoisted_7 = { style: {"color":"var(--blue)"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_TableList = _resolveComponent("TableList")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createBlock(_component_TableList, {
      ref: "TableList",
      dataList: _ctx.list,
      columnAllData: _ctx.columnAllData,
      showSelection: false,
      canRefresh: false,
      canChangeColumn: false,
      isShowPagination: false,
      canCommand: false,
      showSummary: false,
      maxHight: 224
    }, {
      typeName: _withCtx((scope) => [
        _createVNode(_component_el_tag, {
          type: scope.row.amount < 0 ? 'warning' : 'success',
          size: "small",
          effect: "light"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(scope.row.amount < 0 ? '客户退款' : '客户收款'), 1)
          ]),
          _: 2
        }, 1032, ["type"])
      ]),
      amount: _withCtx((scope) => [
        _createElementVNode("span", {
          style: _normalizeStyle({ color: scope.row.amount < 0 ? '#e6a23c' : 'inherit', fontWeight: scope.row.amount < 0 ? '600' : 'normal' })
        }, _toDisplayString(scope.row.amount < 0 ? `-${_ctx.$currency(Math.abs(scope.row.amount))}` : _ctx.$currency(scope.row.amount)), 5)
      ]),
      _: 1
    }, 8, ["dataList", "columnAllData"])), [
      [_directive_loading, _ctx.listLoading]
    ]),
    (_ctx.list.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, [
            _cache[0] || (_cache[0] = _createTextVNode("实收累计：", -1)),
            _createElementVNode("strong", _hoisted_4, _toDisplayString(_ctx.$currency(_ctx.summary.totalReceived)), 1)
          ]),
          _createElementVNode("span", _hoisted_5, [
            _cache[1] || (_cache[1] = _createTextVNode("退款累计：", -1)),
            _createElementVNode("strong", _hoisted_6, _toDisplayString(_ctx.$currency(_ctx.summary.totalRefund)), 1)
          ]),
          _createElementVNode("span", null, [
            _cache[2] || (_cache[2] = _createTextVNode("净收总额：", -1)),
            _createElementVNode("strong", _hoisted_7, _toDisplayString(_ctx.$currency(_ctx.summary.netFee)), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}